import { useEffect, useState } from "react";
import { formatNumber } from "src/MarketDataComponents/Helpers";
import { generateGuid } from 'src/Utils';

const circleStyles = {
    Stock: "fas fa-circle padding-right-5 darkblue-400-text",
    Bond: "fas fa-circle padding-right-5 orange-400-text",
    Cash: "fas fa-circle padding-right-5 green-400-text",
    Other: "fas fa-circle padding-right-5 lightblue-400-text",
    Property: "fas fa-circle padding-right-5 red-400-text",
}

export default function AssetAllocation({asset, assetShort, assetNet, assetCategory, page}) {
    const [assetCols, setAssetCols] = useState(null);

    useEffect(() => {
        let cols = {
            asset,
            assetNet, 
            assetShort, 
            assetCategory
        };
        
        const rows = ['Stock', 'Bond', 'Cash', 'Other', 'Property'];

        for (let col in cols) {
            if(!cols[col].length) {
                for (let i in rows) {
                    cols[col].push({id: i, value: null, label: rows[i]});
                }
            }
        }

        setAssetCols(cols);
    }, []);

    const renderRows = () => {
        return assetCols.asset.map(long => {
            return assetCols.assetShort.map(short => {
                return assetCols.assetNet.map(net => {
                    return assetCols.assetCategory.map(cat => {
                        if (long.label === short.label && long.label === net.label && long.label === cat.label) {
                            if (page === 'overview' || long.label !== 'Property') {
                                return <tr key={generateGuid()}>
                                    <td scope="row" className="font-weight-bold" data-testid={`${(long.label).toLowerCase()}Label`}>
                                        {page !== 'overview' ? <i className={circleStyles[long.label]} style={{color: '#27477B'}} /> : null} {long.label}
                                    </td>
                                    <td aria-label="Long" data-testid={`${(long.label).toLowerCase()}LongValue`}>{long.value !== null ? formatNumber(long.value, 2) : '-'}</td>
                                    <td aria-label="Short" data-testid={`${(long.label).toLowerCase()}ShortValue`}>{short.value !== null ? formatNumber(short.value, 2) : '-'}</td>
                                    <td aria-label="Net" data-testid={`${(long.label).toLowerCase()}NetValue`}>{net.value !== null ? formatNumber(net.value, 2) : '-'}</td>
                                    <td aria-label="Category" data-testid={`${(long.label).toLowerCase()}CatValue`}>{cat.value !== null ? formatNumber(cat.value, 2) : '-'}</td>
                                </tr>
                            }
                        }
                    })
                })
            })
        });
    }

    return assetCols ? <table className={`data-table data-table--small data-table--scroll margin-0 ${page !== 'overview' ? 'highlight' : ''}`}>
        <thead>
            <tr>
                <th></th>
                <th data-testid={`${page}LongTableHead`}>Long</th>
                <th data-testid={`${page}ShortTableHead`}>Short</th>
                <th data-testid={`${page}NetTableHead`}>Net</th>
                <th data-testid={`${page}CatTableHead`}>Category</th>
            </tr>
        </thead>
        <tbody>
            {renderRows()}
        </tbody>
    </table> : null
}